import { Controller } from "@hotwired/stimulus"
import { Popover } from "bootstrap"

export default class extends Controller {
  connect() {
    this.popover = new Popover(this.element, {
      content: this.element.dataset.popoverContentValue,
      container: "body",
      customClass: "pb-inventory-popover",
      placement: "auto",
      trigger: "focus"
    })
  }

  disconnect() {
    this.popover?.dispose()
  }
}
